/* Kylie global JS — wishlist + add to cart */
(function(){
  /* Wishlist — localStorage based */
  function getLiked() {
    try { return JSON.parse(localStorage.getItem('kylie_liked') || '[]'); } catch(e) { return []; }
  }
  function setLiked(arr) {
    localStorage.setItem('kylie_liked', JSON.stringify(arr));
  }
  function isLiked(id) { return getLiked().indexOf(id) >= 0; }
  function toggleLike(id) {
    var arr = getLiked();
    var idx = arr.indexOf(id);
    if(idx >= 0) { arr.splice(idx, 1); } else { arr.push(id); }
    setLiked(arr);
  }

  /* Initialize wishlist buttons */
  function initWishlist() {
    document.querySelectorAll('[data-kh-wishlist]').forEach(function(btn) {
      var pid = btn.getAttribute('data-kh-wishlist');
      if(isLiked(pid)) btn.classList.add('is-liked');
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        toggleLike(pid);
        btn.classList.toggle('is-liked');
      });
    });
  }

  /* Add to cart — Shopify AJAX */
  function initAddToCart() {
    document.querySelectorAll('[data-kh-addcart]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        var variantId = btn.getAttribute('data-kh-addcart');
        if(!variantId) return;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        }).then(function(r) { return r.json(); }).then(function() {
          btn.textContent = 'Added!';
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
          setTimeout(function() { btn.textContent = '+ Add to Cart'; btn.disabled = false; }, 1500);
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cart.item_count } }));
          });
        }).catch(function() {
          btn.textContent = 'Error';
          setTimeout(function() { btn.textContent = '+ Add to Cart'; btn.disabled = false; }, 1500);
        });
      });
    });
  }

  /* Run on load and on DOMContentLoaded */
  function init() { initWishlist(); initAddToCart(); }
  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================
   SIDE MENU — left slide-in navigation
   ========================================================= */
(function(){
  var side = document.querySelector('[data-kh-side]');
  if(!side) return;
  var panel = side.querySelector('[data-kh-side-panel]');
  var overlay = side.querySelector('[data-kh-side-overlay]');
  var closeBtn = side.querySelector('[data-kh-side-close]');
  var views = side.querySelectorAll('[data-kh-side-panel-view]');
  var navStack = ['main'];

  function open() {
    side.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    side.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function() {
      navStack = ['main'];
      updateViews();
    }, 250);
  }
  function push(id) {
    navStack.push(id);
    updateViews();
  }
  function pop() {
    if(navStack.length > 1) { navStack.pop(); updateViews(); }
  }
  function updateViews() {
    var active = navStack[navStack.length - 1];
    views.forEach(function(v) {
      var vid = v.getAttribute('data-kh-side-panel-view');
      v.classList.remove('is-active', 'is-prev');
      if(vid === active) v.classList.add('is-active');
      else if(navStack.indexOf(vid) < navStack.indexOf(active)) v.classList.add('is-prev');
    });
  }

  if(overlay) overlay.addEventListener('click', close);
  if(closeBtn) closeBtn.addEventListener('click', close);
  side.querySelectorAll('[data-kh-side-close]').forEach(function(b) { b.addEventListener('click', close); });
  side.querySelectorAll('[data-kh-side-push]').forEach(function(b) {
    b.addEventListener('click', function() { push(b.getAttribute('data-kh-side-push')); });
  });
  side.querySelectorAll('[data-kh-side-pop]').forEach(function(b) {
    b.addEventListener('click', pop);
  });
  side.querySelectorAll('.kh-side__link').forEach(function(l) {
    l.addEventListener('click', function() { if(!l.classList.contains('kh-side__link--sub')) close(); });
  });

  document.addEventListener('keydown', function(e) { if(e.key === 'Escape') close(); });
  window.kylieSideMenu = { open: open, close: close };

  /* Load collections via Shopify AJAX */
  var collectionsList = side.querySelector('[data-kh-side-collections]');
  if(collectionsList && collectionsList.querySelector('.kh-side__empty-text')) {
    fetch('/collections.json?limit=50').then(function(r) { return r.json(); }).then(function(data) {
      if(data.collections && data.collections.length > 0) {
        collectionsList.innerHTML = data.collections.map(function(c) {
          return '<li class="kh-side__item"><a href="/collections/' + c.handle + '" class="kh-side__link"><span class="kh-side__indicator"></span><span>' + c.title + '</span><span class="kh-side__dot"></span></a></li>';
        }).join('');
        collectionsList.querySelectorAll('a').forEach(function(a) { a.addEventListener('click', close); });
      } else {
        collectionsList.innerHTML = '<li class="kh-side__empty-text">No collections found</li>';
      }
    }).catch(function() {
      collectionsList.innerHTML = '<li class="kh-side__empty-text">No collections found</li>';
    });
  }
})();

/* =========================================================
   CART DRAWER — right slide-in
   ========================================================= */
(function(){
  var cart = document.querySelector('[data-kh-cart-drawer]');
  if(!cart) return;
  var overlay = cart.querySelector('[data-kh-cart-overlay]');
  var closeBtn = cart.querySelector('[data-kh-cart-close]');
  var itemsEl = cart.querySelector('[data-kh-cart-items]');
  var footerEl = cart.querySelector('[data-kh-cart-footer]');
  var totalEl = cart.querySelector('[data-kh-cart-total]');
  var autoCloseTimer = null;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function open() {
    cart.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function close() {
    cart.classList.remove('is-open');
    document.body.style.overflow = '';
    if(autoCloseTimer) { clearTimeout(autoCloseTimer); autoCloseTimer = null; }
  }
  function refreshCart() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      renderCart(c);
      document.querySelectorAll('[data-kh-cart]').forEach(function(b) {
        if(c.item_count > 0) { b.textContent = c.item_count; b.style.display = 'flex'; }
        else { b.style.display = 'none'; }
      });
    });
  }
  function renderCart(c) {
    if(!c.items || c.items.length === 0) {
      itemsEl.innerHTML = '<div class="kh-cart__empty"><div class="kh-cart__empty-icon"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div><span class="kh-cart__empty-text">Your shopping bag is empty.</span><a href="/collections/all" class="kh-cart__empty-btn" data-kh-cart-close>Explore Products</a></div>';
      footerEl.style.display = 'none';
      cart.querySelectorAll('[data-kh-cart-close]').forEach(function(b) { b.addEventListener('click', close); });
      return;
    }
    var html = c.items.map(function(item) {
      return '<div class="kh-cart-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="kh-cart-item__img"><img src="' + (item.image || '') + '" alt="' + item.title + '" loading="lazy"></a>' +
        '<div class="kh-cart-item__info">' +
          '<div class="kh-cart-item__top">' +
            '<div class="kh-cart-item__header">' +
              '<div><h3 class="kh-cart-item__title"><a href="' + item.url + '">' + item.product_title + '</a></h3>' +
              (item.variant_title ? '<div class="kh-cart-item__variant">' + item.variant_title + '</div>' : '') +
              '<div class="kh-cart-item__qty">Qty: ' + item.quantity + '</div></div>' +
              '<span class="kh-cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="kh-cart-item__remove" data-kh-cart-remove="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
    itemsEl.innerHTML = html;
    totalEl.textContent = formatMoney(c.total_price);
    footerEl.style.display = 'flex';
    itemsEl.querySelectorAll('[data-kh-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-kh-cart-remove');
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) }).then(function(r) { return r.json(); }).then(refreshCart);
      });
    });
  }

  if(overlay) overlay.addEventListener('click', close);
  if(closeBtn) closeBtn.addEventListener('click', close);
  cart.querySelectorAll('[data-kh-cart-close]').forEach(function(b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e) { if(e.key === 'Escape') close(); });

  window.kylieCart = { open: open, close: close, refresh: refreshCart };

  /* Auto-open on add to cart (desktop only) */
  window.addEventListener('cart:updated', function(e) {
    if(window.innerWidth >= 1024) {
      open();
      if(autoCloseTimer) clearTimeout(autoCloseTimer);
      autoCloseTimer = setTimeout(close, 5000);
    } else {
      refreshCart();
    }
  });
})();

/* =========================================================
   MOBILE BOTTOM DOCK — exact copy of Eldaly dock behavior
   ========================================================= */
(function() {
  var dock = document.querySelector('[data-kh-dock]');
  if(!dock) return;

  /* Wire up cart triggers */
  dock.querySelectorAll('[data-kh-dock-cart-trigger]').forEach(function(b) {
    b.addEventListener('click', function(e) {
      e.preventDefault();
      var d = document.querySelector('#cart-drawer');
      if(d && d.open) d.open();
    });
  });

  /* Active dock tab — exact Eldaly logic */
  var path = window.location.pathname;
  var isHome = path === '/' || path === '' || /^\/[a-z]{2}(\/)?$/.test(path);
  document.querySelectorAll('[data-kh-dock-tab]').forEach(function(tab) {
    var k = tab.getAttribute('data-kh-dock-tab');
    if((k === 'home' && isHome) || (k === 'liked' && path.indexOf('liked') > -1)) {
      tab.classList.add('is-active');
    }
  });

  /* Mobile dock morph: "Explore Collection" CTA on home (not scrolled) -> capsule on scroll */
  function getScrollY() {
    var pw = document.querySelector('.page-wrapper');
    if(pw && pw.scrollTop) return pw.scrollTop;
    return window.scrollY || 0;
  }
  function updateDock() {
    var scrolled = getScrollY() > 5;
    if(isHome && !scrolled) dock.classList.add('is-explore');
    else dock.classList.remove('is-explore');
  }
  window.addEventListener('scroll', updateDock, { passive: true });
  var pw = document.querySelector('.page-wrapper');
  if(pw) pw.addEventListener('scroll', updateDock, { passive: true });
  updateDock();

  var exploreEl = dock.querySelector('[data-kh-dock-explore]');
  if(exploreEl) {
    dock.addEventListener('click', function(e) {
      if(dock.classList.contains('is-explore')) {
        e.preventDefault();
        var target = window.innerHeight * 0.85;
        var pw2 = document.querySelector('.page-wrapper');
        if(pw2) pw2.scrollTo({ top: target, behavior: 'smooth' });
        else window.scrollTo({ top: target, behavior: 'smooth' });
      }
    });
  }

  /* Product page dock buttons -> dispatch events to product section */
  var dockBuyNow = dock.querySelector('[data-kh-dock-buynow]');
  var dockAtc = dock.querySelector('[data-kh-dock-atc]');
  var dockCart = dock.querySelector('[data-kh-dock-cart]');
  if(dockBuyNow) dockBuyNow.addEventListener('click', function() {
    window.dispatchEvent(new CustomEvent('kylie-dock-buynow'));
  });
  if(dockAtc) dockAtc.addEventListener('click', function() {
    window.dispatchEvent(new CustomEvent('kylie-dock-atc'));
  });
  if(dockCart) dockCart.addEventListener('click', function() {
    var d = document.querySelector('#cart-drawer');
    if(d && d.open) d.open();
  });

  /* Update cart badge — always visible like Eldaly */
  window.addEventListener('cart:updated', function(e) {
    if(e.detail && e.detail.item_count !== undefined) {
      dock.querySelectorAll('[data-kh-cart]').forEach(function(b) {
        b.textContent = e.detail.item_count;
      });
    }
  });
})();
